<dashboard-loader
  *ngIf="loadingSelectedStudySubscription$ | async"
  [title]="'Loading subscription page details...'"
></dashboard-loader>
<div
  *ngIf="selectedStudySubscriptionLoaded$ | async"
  class="dashboard-subscription"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
  fxLayoutGap="40px"
>
  <mat-tab-group
    mat-stretch-tabs
    dynamicHeight
    fxLayout="column"
    fxLayoutAlign="center"
    fxFill
    (selectedTabChange)="onSubscriptionTabChange($event)"
  >
    <mat-tab>
      <ng-template mat-tab-label>
        GENERAL
        <mat-icon *ngIf="selectedStudySubscription?.translations?.length < supportedLanguages?.length" style="color: red; vertical-align: top; font-size: 1.25em;" matTooltip="{{ error_msg_lang }}">!</mat-icon>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        PAGES
        <mat-icon *ngIf="informativePages?.length === 0" style="color: red; vertical-align: top; font-size: 1.25em;" matTooltip="{{ error_msg_pages }}">!</mat-icon>
      </ng-template>
    </mat-tab>
    <mat-tab [label]="SUBSCRIPTION_PAGE_TABS.QUESTIONS | uppercase"></mat-tab>
  </mat-tab-group>

  <div *ngIf="selectedStudy" class="dashboard-subscription__right" fxLayout="column">
    <div *ngFor="let item of selectedStudySubscription?.translations">
      <div fxLayoutAlign="start" *ngIf="item?.language === selectedLanguage?.code; else emptyTitle">
        <label class="dashboard-subscription__right-title">{{ item?.translation }}</label>
      </div>
      <ng-template #emptyTitle>
        <label
          *ngIf="selectedStudySubscription?.translations?.length < supportedLanguages?.length"
          class="dashboard-subscription__right-title dashboard-subscription__right-title--hidden"
        >
          Empty title</label
        >
      </ng-template>
    </div>
    <form
      *ngIf="tab === 0"
      fxLayout="column"
      fxLayoutGap="30px"
      fxLayoutAlign="center"
      [formGroup]="subscriptionForm"
    >
      <div>
        <mat-tab-group
          mat-align-tabs="end"
          (selectedTabChange)="selectTemplateLanguage($event)"
          #languageTabs
          [disablePagination]="true"
          [selectedIndex]="selectedLanguage?.tabIndex"
          (animationDone)="selectFirstTab()"
        >
          <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
            <ng-container *ngTemplateOutlet="tabContent"></ng-container>
          </mat-tab>
        </mat-tab-group>
        <ng-template #tabContent>
          <div formArrayName="translations" *ngFor="let item of translations?.controls; let i = index">
            <mat-form-field [formGroupName]="i" *ngIf="item.get('language').value === selectedLanguage.code" fxFill>
              <input matInput formControlName="translation" placeholder="Subscription page title" />
              <mat-error
                *ngIf="item.get('identifier').value === 'title' && item.get('translation').hasError('required')"
              >
                Subscription page title is <strong>required</strong>
              </mat-error>
              <mat-error
                *ngIf="item.get('identifier').value === 'title' && item.get('translation').hasError('maxlength')"
              >
                Title should have
                <strong>at most {{ item.get('translation').errors?.maxlength.requiredLength }}</strong>
                characters
              </mat-error>
            </mat-form-field>
          </div>
        </ng-template>
      </div>
      <div fxLayout="column" fxLayoutGap="10px">
        <div fxLayout="row" fxFill fxLayoutGap="30px">
          <mat-form-field fxFlex="50">
            <input
              matInput
              [ngxMatDatetimePicker]="subscriptionStartsPicker"
              placeholder="Subscription opens"
              formControlName="startsAt"
              [max]="now"
            />
            <mat-datepicker-toggle matSuffix [for]="subscriptionStartsPicker"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #subscriptionStartsPicker [showSeconds]="false" [stepHour]="1" [stepMinute]="1">
            </ngx-mat-datetime-picker>
            <mat-error *ngIf="startsAt.hasError('required')">
              Subscription opens is <strong>required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="50">
            <input
              matInput
              [ngxMatDatetimePicker]="subscriptionEndsPicker"
              placeholder="Subscription ends"
              formControlName="endsAt"
              [min]="now"
            />
            <mat-datepicker-toggle [disabled]="false" matSuffix [for]="subscriptionEndsPicker"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #subscriptionEndsPicker [showSeconds]="false" [stepHour]="1" [stepMinute]="1">
            </ngx-mat-datetime-picker>
            <mat-error *ngIf="endsAt.hasError('required')"> Subscription ends is <strong>required</strong> </mat-error>
          </mat-form-field>
        </div>
        <mat-error *ngIf="startsAt.value && endsAt.value && subscriptionForm.hasError('endDateInvalid')">
          Subscription ends at must be a date after starts at.
        </mat-error>
        <mat-error *ngIf="startsAt.value && endsAt.value && subscriptionForm.hasError('startDateInvalid')">
          Subscription starts at must be date and time before this moment.
        </mat-error>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxLayout.lt-md="column"
        fxLayoutGap.lt-md="20px"
        fxLayoutAlign.lt-md="space-between start"
      >
        <div class="dashboard-subscription__right-url" fxLayout="row" fxFlex="50" fxFlexAlign="start">
          <mat-card class="dashboard-modules__left-scroll-module-card">
            <ng-container>
              <mat-card-header>
                <mat-card-title class="dashboard-modules__left-scroll-module-card-title">
                  Enrolment Codes
                </mat-card-title>
              </mat-card-header>
              <mat-card-content class="dashboard-modules__left-scroll-module-card-content">
                <div fxLayout="row">
                  These voucher and QR-codes are enrolment codes. Share these codes with participants, such that they can enrol for your study.
                </div>
                <div fxLayout="row">
                  <div fxLayout="column" style="width: 50%; text-align: center;">
                    <h1 style="margin-top: 5rem;">VOUCHER CODE</h1>
                    <p style="margin-top: 2rem; font-size: 30px;"> {{ getStudyHash(selectedStudy) }} </p>
                  </div>
                  <qrcode id="qrcode" [qrdata]="getStudyHash(selectedStudy)" elementType="img" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
                </div>
              </mat-card-content>
              <mat-divider [inset]="true"></mat-divider>
              <mat-card-actions
                class="dashboard-modules__left-scroll-module-card-actions"
                fxLayout="row"
                fxLayoutAlign="end center"
              >
                <button mat-button color="primary" (click)="saveAsImage('qrcode')">
                  Download QR Code as Image
                </button>
              </mat-card-actions>
            </ng-container>
          </mat-card>
        </div>
        <button mat-raised-button fxFlexAlign="top-end" color="accent" (click)="saveSubscription()">
          {{ 'Save' | uppercase }}
        </button>
      </div>
    </form>
    <div *ngIf="tab === 1" fxLayout="column" fxLayoutGap="50px" fxLayoutAlign="center">
      <dashboard-informative-pages-template
        [selectedLanguage]="selectedLanguage"
        [supportedLanguages]="supportedLanguages"
      >
      </dashboard-informative-pages-template>
    </div>
    <div *ngIf="tab === 2" fxLayout="column" fxLayoutGap="50px" fxLayoutAlign="center">
      <dashboard-module-item-list [isScreening]="true" fxFill></dashboard-module-item-list>
    </div>
  </div>
</div>
